<div class="modal-body destineringdialog-scroll">
  @if (alternativaHandelssortimentlist && kundorderradHandelssortimentlist) {
    <div>
      <rask-list [data]="alternativaHandelssortimentlist" [fixedHeader]="true" [innerHeader]="true">
        <rask-list-column header="Alternativa handelssortiment" field="mottagningsplatsNamn"></rask-list-column>
        <rask-list-column header="Lägg till" field="">
          <ng-template let-row="row">
            <rask-checkbox
              text=""
              [(ngModel)]="row.laggtill"
              [checked]=""
              (change)="selectRow(row)"
              [disabled]="!!selectedRow && row !== selectedRow">
            </rask-checkbox>
          </ng-template>
        </rask-list-column>
      </rask-list>
    </div>
    <div class="list-padding">
      <rask-list [data]="kundorderradHandelssortimentlist" [fixedHeader]="true" [innerHeader]="true">
        <rask-list-column header="Kundorderrader" field="mottagningsplatsNamn"></rask-list-column>
        <rask-list-column header="Lägg till" field="">
          <ng-template let-row="row">
            <rask-checkbox
              text=""
              [(ngModel)]="row.laggtill"
              [checked]=""
              (change)="selectRow(row)"
              [disabled]="!!selectedRow && row !== selectedRow">
            </rask-checkbox>
          </ng-template>
        </rask-list-column>
      </rask-list>
    </div>
  } @else {
    <div>
      <p>Laddar möjliga destineringsalternativ, behandlar arbetsorder {{laddadeArbetsordrar}} av
      {{data.arbetsorderIdList.length}}...</p>
    </div>
  }
</div>

@if (validationMessages?.length > 0) {
  <div>
    @for (message of validationMessages; track message) {
      <div>
        <rask-validation-message-row [type]="message.type" [message]="message.text">
        </rask-validation-message-row>
      </div>
    }
  </div>
}
<div class="modal-footer">
  <rask-button aid="buttonSpara" color="primary" (click)="save()" [disabled]="!canSave()">Spara</rask-button>
  <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
</div>